import {AccountItem} from "../../manager/DefineInterface";
import O1HD from "../../../../engines/gameEngine";
import normalMode from "../../normalMode";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;
/**
 * 账户item Node
 */
@ccclass
export default class AccountItemNode extends cc.Component {

    @property({type:cc.Label,displayName:"标题内容"})
    lbTitle : cc.Label = null;
    @property({type:cc.RichText,displayName:"描述"})
    lbDesc : cc.RichText = null;

    private mAccountItemData : AccountItem;
    private mParentScript : normalMode;

    onLoad () {}

    start () {

    }

    /**
     *
     * @param contentDesc 内容描述
     * @param valueArray value数组
     */
    bindData( accountItem : AccountItem , mParentScript : normalMode ){
        // 手术费5万元，期限50日。每日需还1000元
        this.mAccountItemData = accountItem;
        this.mParentScript = mParentScript;
        let desc = this._replaceAllParams( this.mAccountItemData.desc , this.mAccountItemData.paramsArray );
        desc = desc + `\n<color=#3faf79>（已还清${this.mAccountItemData.hasPayDays}日）</color>`;
        this.lbDesc.string = desc;
        this.lbTitle.string = this.mAccountItemData.title;
    }

    /**
     * 一次性还清
     */
    onBtnRepaymentAll(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        //
        let accountData = this.mAccountItemData;
        let needPayMoney = accountData.totalFee - (accountData.hasPayDays * accountData.everyDayPay);
        // Math.floor( this.mAccountItemData.totalFee / this.mAccountItemData.needPayDays )
        //     * ( this.mAccountItemData.needPayDays - this.mAccountItemData.hasPayDays );
        if ( O1HD.getServices().userSrv.getCoins() < needPayMoney ) {
            //TODO 弹窗 提示 余额不足，
            O1HD.getModules().uiControlModule.showMessageBox("余额不足", this.node );
            
            NormalGameManager._instance.openBankPage();
            return;
        }

        //扣除该 账单的所需资金
        O1HD.getServices().userSrv.setCoins( -needPayMoney , true );
        let findIndex = this.mParentScript.gameManager.getGameData().userAccountInfo.findIndex(( item , index , dataList )=>{
            return item.uniqueId == this.mAccountItemData.uniqueId;
        });
        if ( findIndex != -1 ) {
            NormalGameManager._instance.payOffTheCreditDispose(accountData);
            this.mParentScript.gameManager.getGameData().userAccountInfo.splice( findIndex , 1 );
        }
        this.mParentScript.gameManager.writeGameData();

        let uiControlModule = O1HD.getModules().uiControlModule;
        uiControlModule.showMessageBox("还款成功");

        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 匹配通配后的富文本
     * @private
     */
    private _replaceAllParams( content : string , paramsArray : string[] ) : string {
        let retContent = content;
        for ( let param of paramsArray ) {
            retContent = retContent.replace( "@" , `<color=#e05636>${param}</color>` );
        }
        return retContent;
    }
}
